import { TrackedArray } from 'tracked-built-ins';
import { service } from '@ember/service';
import Model, { attr } from '@ember-data/model';

const STATUS_ACTIVE = 'active';

export default class StripeAchBankAccountModel extends Model {
  @service intl;

  @attr() bankName;
  @attr() accountNumberLast4;
  @attr() accountType;
  @attr() stripeCustomerId;
  @attr() stripePaymentMethodId;
  @attr() nickname;
  @attr() status;
  @attr() deactivationReasonCode;

  get infoString() {
    if (this.nickname?.trim()) return this.nickname;

    return this.intl.t('billing.paymentMethods.achInfoString', {
      bank: this.bankName,
      last4: this.accountNumberLast4,
    });
  }

  get isActive() {
    return this.status === STATUS_ACTIVE;
  }

  static fieldsFor(_context) {
    let fields = new TrackedArray();
    this.fields.forEach((_, v) => fields.push(v));
    return fields;
  }
}
